module.exports = __webpack_public_path__ + "img/successround.5caeaef5.png";